function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "111.85mm",
    height: "99.96mm",
    viewBox: "0 0 111.85 99.96",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-46.057 -8.8187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m51.868 8.8187c-2.2084-0.02339-3.0754 2.1896-3.6504 4.8886-1.5069 14.084-7.0943 24.64 9.0615 54l-6.9794 14.327c15.975 0.81331 31.438 8.5177 46.408 22.898 3.2294 3.2574 6.4443 6.6596 10.653 0.12248 12.773-10.99 25.655-21.852 46.776-23.02l-6.8575-14.082c7.4066-12.834 13.076-27.642 9.5508-52.898-0.15729-5.7671-3.5472-5.0682-6.612-5.0204l-19.715 7.4693-15.061 7.7143c-11.129-3.245-18.882-1.6682-26.572 0l-14.326-7.3468-18.735-7.4693c-1.6569-1.0991-2.938-1.5722-3.9419-1.5828zm77.008 45.491c0.79657-0.02009 1.0348 0.87692 0.35915 3.1822-3.2033 10.929-14.132 9.7984-14.132 9.7984s10.793-12.905 13.773-12.981zm-53.837 0.68006c2.8156-0.03926 15.379 13.243 15.379 13.243s-10.741 0.56537-15.263-10.175c-0.91859-2.1817-0.83398-3.0575-0.11627-3.0675zm20.34 34.266h14.509l-4.7108 5.0875c-2.3693 1.832-3.752 0.70357-5.2762 0l-4.5222-5.0875z",
    fillRule: "evenodd",
    style: {
      paintOrder: "markers stroke fill"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFox);
export default __webpack_public_path__ + "static/media/fox.0e45efc540a9e1a6851c0df6c73b0074.svg";
export { ForwardRef as ReactComponent };